import { sharedEnvironment } from '@vinnova/environments';

const bedomningsPortalApiBaseURI = `${sharedEnvironment.acc.gatewayUrl}/bedomningsportal`;

export const environment = {
  production: sharedEnvironment.acc.production,
  name: sharedEnvironment.acc.name,
  etjansterCommonUrl: sharedEnvironment.acc.etjansterCommonUrl,
  ansokanUrl: sharedEnvironment.acc.ansokanUrl,
  bpUrl: sharedEnvironment.acc.bpUrl,
  cookieDomain: sharedEnvironment.acc.cookieDomain,
  bedomningsPortalApiUrl: bedomningsPortalApiBaseURI,
  etjansterCommonApiUrl: `${sharedEnvironment.acc.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.acc.gatewayUrl}/resourcestring/BP`,
  projektUrl: sharedEnvironment.acc.projektUrl,
  externalLinks: sharedEnvironment.acc.externalLinks,
  baseGatewayUrl: sharedEnvironment.acc.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.acc.apimSubscriptionKey,
  chatbotApiUrl: bedomningsPortalApiBaseURI + '/chatbot',
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      bedomningsPortalApiBaseURI,
      sharedEnvironment.acc.azureAdB2C.clientId.bedomningsportalClientId,
      sharedEnvironment.acc.azureAdB2C.clientId.bedomningsportalApiClientId,
    ),
    authority: sharedEnvironment.acc.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.acc.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.acc.azureAdB2C.clientId.bedomningsportalApiClientId}/all`,
    tenant: sharedEnvironment.acc.azureAdB2C.tenant,
    policies: sharedEnvironment.acc.azureAdB2C.policies,
    clientId: sharedEnvironment.acc.azureAdB2C.clientId,
  },
};
